// js/Component/AddressBook/AddressBookEntryRow.jsx
import React from "react";
import toast from "react-hot-toast";
import VideocamIcon from "@mui/icons-material/Videocam";
import PhoneIcon from "@mui/icons-material/Phone";
import EditIcon from "@mui/icons-material/EditRounded";
import TrashIcon from "@mui/icons-material/DeleteRounded";
import ContentCopy from "@mui/icons-material/ContentCopy";
import deviceProfile from "images/device.png";
import mobileCover from "images/Mobile-Cover.png";

function formatDateTime(value) {
    if (!value) return "—";
    const d = new Date(value);
    if (isNaN(d.getTime())) return String(value);
    return d.toLocaleString();
}

function copyToClipboard(value) {
    if (!value) return;
    navigator.clipboard.writeText(value);
    toast.success("Copied");
}

function AddressBookEntryRow({
    entry,
    verbose = false,
    deviceImageBase64 = null,
    onEdit,
    onDelete,
}) {
    const isVideo = entry.entryType === "video_contact";
    const TypeIcon = isVideo ? VideocamIcon : PhoneIcon;
    const typeLabel = isVideo ? "Video contact" : "Phone contact";

    const placeholderSrc = isVideo ? deviceProfile : mobileCover;
    let avatarSrc = placeholderSrc;
    if (isVideo && deviceImageBase64) {
        avatarSrc = `data:image/png;base64,${deviceImageBase64}`;
    } else if (!isVideo && entry.avatarUrl) {
        avatarSrc = `${entry.avatarUrl}${entry.avatarUpdatedAt
            ? `?v=${encodeURIComponent(entry.avatarUpdatedAt)}`
            : ""}`;
    }

    return (
        <tr>
            <td style={{ verticalAlign: "middle", whiteSpace: "nowrap" }}>
                <img
                    className="user-photo"
                    src={avatarSrc}
                    alt={entry.displayName || ""}
                    onError={(e) => {
                        e.currentTarget.src = placeholderSrc;
                    }}
                />
                {entry.displayName || "—"}
            </td>
            <td style={{ verticalAlign: "middle", whiteSpace: "nowrap" }}>
                <span
                    title={typeLabel}
                    style={{ display: "inline-flex", alignItems: "center", gap: 6 }}
                >
                    <TypeIcon
                        sx={{
                            fontSize: "1.1rem",
                            color: isVideo ? "#28a745" : "#007bff",
                        }}
                    />
                    {typeLabel}
                </span>
            </td>
            <td
                style={{
                    verticalAlign: "middle",
                    fontFamily: "monospace",
                    fontSize: 12,
                    whiteSpace: "nowrap",
                }}
            >
                {!isVideo ? (entry.phoneNumberRaw || "—") : "—"}
            </td>
            {verbose && (
                <>
                    <td
                        style={{
                            verticalAlign: "middle",
                            fontFamily: "monospace",
                            fontSize: 12,
                            whiteSpace: "nowrap",
                        }}
                    >
                        {isVideo && entry.targetDeviceId ? (
                            <>
                                {entry.targetDeviceId}
                                <ContentCopy
                                    className="iconButtonStyle"
                                    sx={{ marginLeft: "5px", cursor: "pointer" }}
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        copyToClipboard(entry.targetDeviceId);
                                    }}
                                />
                            </>
                        ) : "—"}
                    </td>
                    <td style={{ verticalAlign: "middle" }}>
                        {entry.source || "—"}
                    </td>
                    <td
                        style={{
                            verticalAlign: "middle",
                            fontSize: 12,
                            whiteSpace: "nowrap",
                        }}
                    >
                        {formatDateTime(entry.updatedAt)}
                    </td>
                    <td
                        style={{
                            verticalAlign: "middle",
                            fontFamily: "monospace",
                            fontSize: 12,
                            whiteSpace: "nowrap",
                        }}
                    >
                        {entry.id}
                        <ContentCopy
                            className="iconButtonStyle"
                            sx={{ marginLeft: "5px", cursor: "pointer" }}
                            onClick={(e) => {
                                e.stopPropagation();
                                copyToClipboard(entry.id);
                            }}
                        />
                    </td>
                </>
            )}
            <td style={{ verticalAlign: "middle", whiteSpace: "nowrap" }}>
                <EditIcon
                    className="iconButtonStyle"
                    sx={{ marginRight: "5px" }}
                    onClick={() => onEdit(entry)}
                />
                <TrashIcon
                    className="iconButtonStyle"
                    onClick={() => onDelete(entry)}
                />
            </td>
        </tr>
    );
}

export default AddressBookEntryRow;
